import PageApp from 'pageApp';
import Radio from 'backbone.radio';
import Logger from '@core/util/universal-logger';
import ExperimentationSDK from '@component/experiment/src/js/ExperimentationSDK';
import ObjectUtil from '@core/util/object';
import Properties from '../util/Properties';
import AddToBagController from '../add-to-bag/AddToBagController';
import { Actions } from '../util/Constants';

export function isMediumATBEligible(model) {
  const isFullPageAddToBaginterstitial = ObjectUtil.getChildProperty(model, 'attributes.properties.isFullPageAddToBaginterstitial');
  const notMobile = !!ObjectUtil.getChildProperty(model, 'attributes.properties.isMobile');
  return isFullPageAddToBaginterstitial && !notMobile;
}

function loadAddToBagInterstitial(responseData, productModel) {
  import(/* webpackChunkName: 'add-to-bag-interstitial' */ '@component/add-to-bag-interstitial')
    .then((Obj) => {
      const AddToBagInterstitial = Obj.default ? Obj.default : Obj;
      const isMediumATB = isMediumATBEligible(productModel);
      // eslint-disable-next-line no-new
      new AddToBagInterstitial({
        data: responseData,
        assetsHost: productModel.get('product').urlTemplate.product,
        responsiveBagNewUrlKS: Properties.get('responsiveBagNewUrlEnabled'),
        pageType: ObjectUtil.getChildProperty(productModel, 'attributes.utagData.page_type'),
        deviceType: ObjectUtil.getChildProperty(productModel, 'attributes.context.deviceType'),
        isFullPageAddToBaginterstitial: isMediumATB,
        isRviRelatedATBProsZonesEnabled: false,
      });

      const atbChannel = Radio.channel('add-to-bag');

      atbChannel.on(Actions.addToBag.showModal, () => {
        PageApp.channel.trigger(Actions.prosFactory.renderProsATB);
      });
    })
    .catch(Logger.error);
}

export function onAddToBagClick(ctaData) {
  const addToBagController = new AddToBagController(ctaData);
  addToBagController.fireAddToBagCall();
}

export function onAddToBagSuccess({
  responseData,
  productModel,
}) {
  // Experiment for suppressing AtB on mobile
  const isSuppressATBInterstitial = ObjectUtil.getChildProperty(productModel, 'attributes.properties.suppressAddToBagInterstitial');
  if (!$('#pdp-overlay-modal-id').hasClass('visible')) {
    if (isSuppressATBInterstitial) {
      AddToBagController.triggerSuppressATBLinkTag().catch(() => Promise.resolve()).then(() => {
        ExperimentationSDK.isRecipeSelected('403-21').then((supressATBEnabled) => {
          if (supressATBEnabled) {
            PageApp.channel.trigger(Actions.page.redirect, '/my-bag');
          } else {
            loadAddToBagInterstitial(responseData, productModel);
          }
        }, () => loadAddToBagInterstitial(responseData, productModel));
      });
    } else {
      loadAddToBagInterstitial(responseData, productModel);
    }
  }
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/listeners/AddToBagListeners.js